<template>
  <div>
    <b-card style="width: 100%; margin: 0px; padding: 0px;" no-body>
      <span v-if="products.length > 0" style="padding: 10px;">
        <b-card-text>
          <b-card-text v-if="read_only != true">
            <b-card-header class="d-flex justify-content-between align-items-center py-2">
              <h6 class="mb-0"></h6>
              <div class="d-flex align-items-center">
                <!-- Main Schedule Date Control -->
                <div class="d-flex align-items-center mr-3">
                  <label class="mb-0 mr-2 text-nowrap">Main Schedule Date:</label>
                  <date-picker
                    v-model="mainScheduleDate"
                    format="MM-DD-YYYY"
                    valueType="format"
                    placeholder="Select date for all items"
                    style="width: 150px; margin-right: 10px;"
                    class="mr-2"
                  ></date-picker>
                </div>

                <!-- Main Receiving Location Control - AUTO APPLY -->
                <div class="d-flex align-items-center">
                  <label class="mb-0 mr-2 text-nowrap">Receiving Location:</label>
                  <b-form-select
                    v-model="mainReceivingLocation"
                    :options="filteredLocations"
                    size="sm"
                    style="width: 200px; font-size: 12px;"
                  ></b-form-select>
                </div>
              </div>
            </b-card-header>
            <span v-if="products.length > 0">
            <vue-simple-suggest
              v-model="product_search_keyword"
              display-attribute="product_name"
              value-attribute="product_sku"
              :max-suggestions="200"
              :list="products"
              :filter-by-query="true"
              @select="add_item"
              :disabled="packet.userDetails.userrole !== 'admin' && packet.userDetails.userrole !== 'locationadmin'"
              :filter="filter_products"
              ref="product_sku"
              style="margin-bottom: 10px; font-size: 16px; font-family: monospace; border: 1px solid black;"
              class="input-field"
            >
              <div slot="suggestion-item" slot-scope="{ suggestion, autocomplete }">
                <span>{{ suggestion.product_name }} [{{ suggestion.product_sku }}]</span>
              </div>
            </vue-simple-suggest>
          </span>
            <span v-else>
              <b-alert variant="warning" show
                >NO PRODUCTS AVAILABLE FOR VENDOR: {{ packet.vendorsdict[vendor_id] }}</b-alert
              >
            </span>
          </b-card-text>
          <div v-if="items.length > 0" class="diver">
            <b-card-text v-if="items.length > 0">
              <table class="text-monospace" style="width: 100%;">
                <thead>
                  <tr>
                  
                    <td class="srr" style="width: 100px;">PRODUCT SKU</td>
                    <td class="srr" style="width: 200px;">DESCRIPTION</td>
                      <td class="srr" style="width: 100px;">CATEGORY</td>
                    <td class="srr" style="width: 100px;">COLOR</td>
                    <td class="srr" style="width: 60px;">CUBES</td>
                    <td class="srr" style="width: 100px;">FOB</td>
                    <td class="srr" style="width: 100px;">LANDED</td>
                    <td class="srr" style="width: 80px;">ORDER QTY/RCV QTY</td>
                    <td class="srr" style="width: 80px;">ORDER QTY</td>
                    <td class="srr" style="width: 80px;">SCH QTY</td>
                    <td class="srr" style="width: 80px;">RCV QTY</td>
                    <td class="srr" style="width: 120px;">STATUS</td>
                    <td class="srr" style="width: 150px;">SCH DATE</td>
                    <td class="srr" style="width: 150px;">RECEIVE LOC</td>
                    <td class="srr" style="width: 150px;">RECEIVE DATE</td>
                    <td class="srr" style="width: 100px;">COMMENTS</td>
                    <td class="srr" v-if="read_only != true" style="width: 120px;">ACTION</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in items" v-bind:key="idx" :style="{}">
                
                    <td class="srrv">{{ item.product_sku }}</td>
                    <td class="srrv">{{ item.product_name }}</td>
                        <td class="srrv">{{ packet.categoriesdict[item.category_id] }}</td>
                    <td class="srrv">
                      <div v-if="read_only != true">
                        <b-form-select
                          :options="colors"
                          v-model="item.color"
                          size="sm"
                          :disabled="isItemDisabled(item)"
                          style="font-size: 11px;"
                        ></b-form-select>
                      </div>
                      <div v-else>{{ item.color }}</div>
                    </td>
                    <td class="srrv">{{ item.cubes }}</td>
                    <td class="srrv">
                      <b-form-input
                        v-model="item.fob_price"
                        size="sm"
                        type="number"
                        :disabled="isItemDisabled(item)"
                        style="font-size: 11px;"
                        readonly
                        step="0.01"
                        min="0.01"
                        @change="validateFobPriceChange(item)"
                      ></b-form-input>
                    </td>
                    <td class="srrv">
                      <b-form-input
                          v-model="item.landed_cost_calculated"
                          size="sm"
                          readonly
                          type="number"
                          :disabled="isItemDisabled(item)"
                          style="font-size: 11px;"
                          step="0.01"
                          min="0.01"
                          @change="validateLandedCostChange(item)"
                      ></b-form-input>
                      <b-form-invalid-feedback :state="validateLandedCost(item)">
                      </b-form-invalid-feedback>
                   </td>
                    <td class="srrv">
                      <div>
                        {{item.quantity_ordered}} / {{ item.quantity_received }}
                      </div>
                    </td>
                    <td class="srrv">
                      <div v-if="read_only != true">
                        <b-form-input
                          v-model="item.quantity_ordered"
                          size="sm"
                          type="number"
                          style="font-size: 11px;"
                          :disabled="isItemDisabled(item)"
                          @change="validateOrderedQuantityChange(item)"
                        ></b-form-input>
                        <b-form-invalid-feedback :state="validateOrderedQuantity(item)">
                          Must be greater than 0
                        </b-form-invalid-feedback>
                      </div>
                      <div v-else>{{ item.quantity_ordered }}</div>
                    </td>
                    <td class="srrv">
                    <div v-if="read_only != true">
                      <b-form-input
                        v-model="item.quantity_scheduled"
                        size="sm"
                        type="number"
                        style="font-size: 11px;"
                        :min="getMinScheduledQuantity(item)"
                        :max="item.quantity_ordered"
                        :disabled="isItemDisabled(item) || !isAdmin"
                        @input="handleScheduledQuantityChange(item)"
                        @blur="validateScheduledQuantity(item)"
                      ></b-form-input>
                      <b-form-invalid-feedback :state="validateScheduledQuantity(item)">
                        Must be between 0 and {{ item.quantity_ordered }}
                      </b-form-invalid-feedback>
                    </div>
                    <div v-else>{{ item.quantity_scheduled }}</div>
                   </td>
                    <td class="srrv">
                      <b-form-input
                        v-model="item.quantity_received"
                        size="sm"
                        type="number"
                        style="font-size: 11px;"
                        :min="getMinQuantity(item)"
                        :max="item.quantity_ordered"
                        :disabled="isItemDisabled(item)"
                        @keydown="preventInvalidEntry($event, item)"
                        @input="validateQuantity(item)"
                      ></b-form-input>
                      <b-form-invalid-feedback :state="validateReceivedQuantity(item)">
                        Must be between {{ getMinQuantity(item) }} and {{ item.quantity_ordered }}
                      </b-form-invalid-feedback>
                    </td>
                    <td class="srrv" :style="{
                        backgroundColor: statusColors[item.status],
                        color: getStatusTextColor(item.status),
                        textAlign: 'center',
                      }">
                      <b-form-select
                        :options="getStatusOptions(item)"
                        v-model="item.status"
                        size="sm"
                        style="font-size: 11px; background: transparent;border: 1px solid rgba(0,0,0,0.3)"
                        :disabled="isItemDisabled(item) || (isWarehouseUser && item.original_status !== 6)  || !isAdmin"
                        @change="handleStatusChange(item)"
                        :state="getStatusState(item)"
                        v-b-tooltip.hover
                        :title="isWarehouseUser ? 'Warehouse users can only set status to RECEIVED' : ''"
                      ></b-form-select>
                    </td>
                    <td class="srrv" style="position: relative;">
                      <date-picker
                        v-model="item.schedule_date"
                        format="MM-DD-YYYY"
                        :disabled="isItemDisabled(item)  || !isAdmin"
                        valueType="format"
                        @change="handleScheduledDateChange(item)"
                        @focus="pullFinalEtaIfScheduleDateNull(item)"
                        @blur="pullFinalEtaIfScheduleDateNull(item)"
                        style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 140px; font-size: 11px;"
                      ></date-picker>
                      <b-badge
                        v-if="item.schedule_date === final_eta"
                        variant="info"
                        style="position: absolute; top: -5px; right: -5px; font-size: 8px;"
                        v-b-tooltip.hover
                        title="Pulled from Final ETA"
                      >
                        ETA
                      </b-badge>
                    </td>
                    <td class="srrv">
                      <b-form-select
                        :options="filteredLocations"
                        v-model="item.locsub"
                        size="sm"
                        :disabled="isItemDisabled(item)  || !isAdmin"
                        style="font-size: 11px;"
                      ></b-form-select>
                    </td>
                    <td class="srrv" readonly>
                      <date-picker
                        readonly
                        v-model="item.receiving_date"
                        format="MM-DD-YYYY"
                        :disabled="(isWarehouseUser && [1,2,3,4,5,6,7,8].includes(item.status)) || isItemDisabled(item)  || !isAdmin"
                        valueType="format"
                        style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 140px; font-size: 11px;"
                      ></date-picker>
                    </td>
                    <td class="srrv">
                      <b-form-input
                        v-model="item.comments"
                        size="sm"
                        type="text"
                        :disabled="isItemDisabled(item)"
                        style="font-size: 11px;"
                      ></b-form-input>
                    </td>
                    <td class="srrv" v-if="read_only != true">
                      <div
                        style="display: flex; align-items: center; justify-content: center; gap: 5px; flex-wrap: nowrap;"
                      >
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          :disabled="isItemDisabled(item)"
                          v-if="packet.userDetails.userrole == 'admin'"
                          @click="confirmRemoveItem(item)"
                          v-b-tooltip.hover
                          title="DELETE ITEM"
                        >
                          <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                        </b-button>

                        <input
                          type="file"
                          accept="image/*"
                          @change="handleImageUpload($event, item, idx)"
                          style="display: none;"
                          :ref="'fileInput-' + idx"
                          :disabled="isItemDisabled(item)"
                        />

                        <b-button
                          v-if="!item.images || item.images.length === 0"
                          size="sm"
                          variant="outline-primary"
                          @click="$refs['fileInput-' + idx][0].click()"
                          :disabled="isItemDisabled(item)"
                          v-b-tooltip.hover
                          title="UPLOAD IMAGES"
                        >
                          <b-icon icon="cloud-upload-fill" aria-hidden="true"></b-icon>
                        </b-button>

                        <div v-else style="position: relative; display: inline-block;">
                          <img
                            :src="item.images[0].raw || item.images[0].url"
                            style="max-width: 40px; max-height: 40px; cursor: pointer;"
                            @click="showImagePreview(item)"
                            class="img-thumbnail"
                          />
                          <b-button
                            variant="danger"
                            size="xs"
                            @click="removeImage(item, idx)"
                            style="position: absolute; top: -8px; right: -8px; padding: 0px 4px;"
                          >
                            ×
                          </b-button>
                        </div>

                        <b-button
                          size="sm"
                          variant="outline-primary"
                          v-if="item.pictures && item.pictures.length"
                          @click="showImages(item.pictures)"
                          v-b-tooltip.hover
                          title="SHOW IMAGES"
                        >
                          <b-icon icon="image-fill" aria-hidden="true"></b-icon>
                        </b-button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-card-text>
            <b-card-text v-else>
              <b-alert show variant="primary">NO ITEMS ADDED TO THIS ORDER YET.</b-alert>
            </b-card-text>
          </div>
          <div>
            <div v-if="items.length > 0">
              <b-button size="sm" variant="success" @click="confirmSave">SAVE</b-button>
              <b-button size="sm" variant="outline-secondary" @click="close_it" class="ml-2"
                >CANCEL</b-button
              >
            </div>
            <div v-else>
              <b-button size="sm" variant="warning" @click="close_it">CANCEL</b-button>
            </div>
          </div>
        </b-card-text>
      </span>
    </b-card>
    <!-- Stock Order History Block -->
    <b-card v-if="stock_order_id" style="margin: 0px; margin-top: 10px; padding: 0px;" no-body>
      <b-alert show>STOCK ORDER HISTORY</b-alert>

      <div v-if="filteredStockOrderHistory.length > 0" class="diver">
        <b-card-text>
          <table style="width: 100%;" class="text-monospace">
            <thead>
              <tr>
                 <td class="srr" style="width:80px">DATE</td>
                 <td class="srr" style="width:100px">SKU</td>
                 <td class="srr" style="width:300px">DESCRIPTION</td>
                 <td class="srr" style="width:100px">QTY ORD</td>
                 <td class="srr" style="width:100px">QTY RCVD</td>
                 <td class="srr" style="width:120px">STATUS</td>
                 <td class="srr" style="width:120px">DROP LOCATION</td>
                 <td class="srr" style="width:100px">CHANGED BY</td>
               </tr>
            </thead>
            <tbody>
              <tr v-for="(historyItem, idx) in filteredStockOrderHistory" :key="idx">
                <td class="srrv">{{ historyItem.change_date }}</td>
                <td class="srrv">{{ historyItem.product_sku }}</td>
                <td class="srrv">{{ historyItem.item_description }}</td>
                <td class="srrv">{{ historyItem.quantity_ordered }}</td>
                <td class="srrv">{{ historyItem.quantity_received }}</td>
                <td class="srrv">{{ historyItem.status_text }}</td>
                <td class="srrv">{{ historyItem.drop_location_name || historyItem.drop_location }}</td>
                <td class="srrv">{{ historyItem.changed_by }}</td>
               </tr>
            </tbody>
           </table>
        </b-card-text>
      </div>

      <div v-else>
        <div v-if="historyLoading">
          <loading
            :active="true"
            :can-cancel="false"
            :is-full-page="false">
          </loading>
        </div>
        <div v-else>
          <b-card-text class="srrv">NO HISTORY FOR THIS STOCK ORDER YET</b-card-text>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Requestor from '@/utilities/Requestor';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'

export default {
  name: "CreateNewStockOrder",
  props: ["viewdata"],
  components: {
    flatPickr,
    Loading,
    DatePicker,
    VueSimpleSuggest
  },
  data: function () {
    return {
      packet: {},
      colors: [
        { value: "gray", text: "GRAY" },
        { value: "brown", text: "BROWN" },
        { value: "white", text: "WHITE" },
        { value: "black", text: "BLACK" },
        { value: "blue", text: "BLUE" },
        { value: "green", text: "GREEN" },
        { value: "violet", text: "VIOLET" },
        { value: "red", text: "RED" },
        { value: "lightblue", text: "LIGHTBLUE" },
        { value: "lightgreen", text: "LIGHTGREEN" },
        { value: "violet", text: "VIOLET" },
        { value: "yellow", text: "YELLOW" },
      ],
      statuses: [
        { value: 1, text: "NEW" },
        { value: 2, text: "ORDERED" },
        { value: 3, text: "SCHEDULED" },
        { value: 4, text: "IN-TRANSIT" },
        { value: 5, text: "PARTIAL" },
        { value: 6, text: "RECEIVED" },
        { value: 7, text: "COMPLETED" },
        { value: 8, text: "ARCHIVED" },
      ],
      stock_order_id: null,
      stock_order_vendor_id: null,
      vendor_id: null,
      ship_to: null,
      bill_to: null,
      requested_eta: null,
      po_number: null,
      po_date: null,
      items: [],
      products: [],
      vendor_products: [],
      product_search_keyword: '',
      loading: null,
      receiving_location_id: null,
      mainScheduleDate: null,
      mainReceivingLocation: null, // ADDED: For auto-applying location to all items
      autoApplyMainDate: true,
      final_eta: null,
      stockOrderHistory: [],
      historyLoading: false,
    }
  },
  computed: {
    isAdmin() {
      return this.packet.userDetails.userrole === 'admin';
    },
    filteredStockOrderHistory() {
      if (!this.stockOrderHistory || this.stockOrderHistory.length === 0) return [];

      const uniqueEntries = new Map();
      const filteredHistory = [];

      for (let i = this.stockOrderHistory.length - 1; i >= 0; i--) {
        const item = this.stockOrderHistory[i];
        const key = `${item.product_sku}-${item.quantity_ordered}-${item.quantity_received}-${item.status_text}-${item.drop_location_name || item.drop_location}`;

        if (!uniqueEntries.has(key)) {
          uniqueEntries.set(key, true);
          filteredHistory.unshift(item);
        }
      }

      return filteredHistory;
    },
    isWarehouseUser() {
      return this.packet.userDetails && this.packet.userDetails.userrole === 'warehouseuser';
    },
    statusClass() {
      return (status) => {
        return {
          'status-new': status === 1,
          'status-ordered': status === 2,
          'status-scheduled': status === 3,
          'status-in-transit': status === 4,
          'status-partial': status === 5,
          'status-received': status === 6,
          'status-completed': status === 7,
          'status-archived': status === 8
        };
      };
    },
    statusColors() {
      return {
        1: '#f8f9fa',
        2: '#e3f2fd',
        3: '#fff3e0',
        4: '#fff3e0',
        5: '#fff9c4',
        6: '#c8e6c9',
        7: '#c8e6c9',
        8: '#f5f5f5'
      };
    },
    filteredLocations() {
      if (!this.receiving_location_id || !this.packet.locsubs) return [];
      const receivingLoc = this.receiving_location_id.toString();

      return this.packet.locsubs.filter(loc => {
        return loc.value.toString().startsWith(receivingLoc + '|') ||
               loc.value.toString() === receivingLoc;
      });
    },
    getStatusOptions() {
      return (item) => {
        if (this.isWarehouseUser) {
          return [{ value: 6, text: "RECEIVED" }];
        }

        if (this.packet.userDetails.userrole !== 'admin') {
          const allowedStatuses = ["RECEIVED", "PARTIAL"];
          return this.statuses.map(status => ({
            ...status,
            disabled: !allowedStatuses.includes(status.text),
          }));
        }

        return this.statuses.map(status => {
          let disabled = false;
          if ([5, 6].includes(item.original_status) && status.value === 8) {
            disabled = true;
          }
          return { ...status, disabled: disabled };
        });
      };
    },
    filteredStatuses() {
      const disabledStatuses = ["ORDERED", "RECEIVED", "PARTIAL"];
      if (this.packet.userDetails.userrole !== 'admin') {
        return this.statuses.map(status => ({
          ...status,
          disabled: !disabledStatuses.includes(status.text),
        }));
      }
      return this.statuses;
    }
  },
  methods: {
    // Auto-apply receiving location to all items
    applyMainReceivingLocation() {
      if (!this.mainReceivingLocation) return;

      let appliedCount = 0;
      this.items.forEach(item => {
        // Only update items that aren't disabled and not received/completed/archived
        if (!this.isItemDisabled(item) && ![6, 7, 8].includes(item.status)) {
          item.locsub = this.mainReceivingLocation;
          appliedCount++;
        }
      });

      if (appliedCount > 0) {
        this.$bvToast.toast(
          `Receiving location applied to ${appliedCount} item(s)`,
          { title: "Auto-Applied", autoHideDelay: 2000, variant: "success" }
        );
      }
    },

    // Auto-apply schedule date to all items
    applyMainScheduleDate() {
      if (!this.mainScheduleDate) return;

      let appliedCount = 0;
      this.items.forEach(item => {
        if (!this.isItemDisabled(item) && item.status !== 6) {
          item.schedule_date = this.mainScheduleDate;
          if (item.status !== 3) {
            item.status = 3;
          }
          if (!item.quantity_scheduled || item.quantity_scheduled === 0) {
            item.quantity_scheduled = item.quantity_ordered;
          }
          appliedCount++;
        }
      });

      this.$bvToast.toast(
        `Schedule date applied to ${appliedCount} item(s)`,
        { title: "Auto-Applied", autoHideDelay: 2000, variant: "success" }
      );
    },

    validateFobPriceChange(item) {
      let price = parseFloat(item.fob_price);
      if (isNaN(price) || price < 0) {
        item.fob_price = null;
        this.$bvToast.toast(
          "FOB price must be a positive number",
          { title: "Invalid Price", autoHideDelay: 3000, variant: "warning" }
        );
      } else {
        item.fob_price = Math.round(price * 100) / 100;
      }
    },

    validateLandedCost(item) {
      const price = parseFloat(item.landed_cost_calculated);
      return !isNaN(price) && price > 0;
    },

    validateLandedCostChange(item) {
      let price = parseFloat(item.landed_cost_calculated);
      if (isNaN(price) || price <= 0) {
        item.landed_cost_calculated = null;
        this.$bvToast.toast(
          "Landed cost must be a positive number",
          { title: "Invalid Price", autoHideDelay: 3000, variant: "warning" }
        );
      } else {
        item.landed_cost_calculated = Math.round(price * 100) / 100;
      }
    },

    calculateLandedCost: function(item) {
      const invoiceTotal = Number(item.total_fob_price) || 0;
      const tariff = Number(item.data.tariff) || 0;
      const transport = Number(item.data.transport) || 0;
      const otherCost = Number(item.data.other_cost) || 0;
      const totalAdditionalCosts = tariff + transport + otherCost;
      const allocationRatio = invoiceTotal > 0 ? totalAdditionalCosts / invoiceTotal : 0;
      item.data.landed = (invoiceTotal + totalAdditionalCosts).toFixed(2);
      item.data.allocation_ratio = allocationRatio.toFixed(4);
    },

    getStatusTextColor(status) {
      return status === 7 ? 'white' : 'black';
    },

    confirmSave() {
      const errors = this.validate({ items: this.items });
      if (errors.length > 0) {
        this.$bvToast.toast(errors[0].message, {
          title: "Validation Error",
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }

      this.$bvModal.msgBoxConfirm('Are you sure you want to save these items?', {
        title: 'Confirm Save',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          this.save_stock_order_items();
        }
      });
    },

    confirmRemoveItem(item) {
      if (!item.stock_order_item_id && (!this.stock_order_id || !item.product_sku)) {
        this.$bvToast.toast(
          "Cannot delete: Missing item information",
          { title: "Error", autoHideDelay: 3000, variant: "danger" }
        );
        return;
      }
      
      this.$bvModal.msgBoxConfirm(`Are you sure you want to delete ${item.product_name}?`, {
        title: 'Confirm Delete',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'DELETE',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          this.executeDelete(item);
        }
      });
    },

    executeDelete(item) {
      let data = {};
      
      if (item.stock_order_item_id) {
        data.stock_order_item_id = item.stock_order_item_id;
      } else {
        data.stock_order_id = this.stock_order_id;
        data.product_sku = item.product_sku;
      }

      let that = this;
      let path = "/api/vendor/delete_stock_order_item/";

      let s = function(response) {
        if (response.data.error) {
          that.$bvToast.toast(
            response.data.error,
            { title: "Error", autoHideDelay: 3000, variant: "warning" }
          );
        } else {
          that.$bvToast.toast(
            "Item deleted successfully",
            { title: "Success", autoHideDelay: 2000, variant: "success" }
          );
          that.items = that.items.filter(d => d.product_sku !== item.product_sku);
          that.fetchStockOrderHistory();
        }
      };

      let f = function(error) {
        console.log("Delete error:", error);
        that.$bvToast.toast(
          "Error occurred while deleting item",
          { title: "Error", autoHideDelay: 3000, variant: "danger" }
        );
      };

      Requestor.postSyncP(path, data, this, s, f);
    },

    validateOrderedQuantity(item) {
      return item.quantity_ordered > 0;
    },

    validateScheduledQuantity(item) {
      const scheduled = Number(item.quantity_scheduled) || 0;
      const ordered = Number(item.quantity_ordered) || 0;

      if (scheduled < 0) {
        item.quantity_scheduled = 0;
        this.$bvToast.toast(
          "Scheduled quantity cannot be negative",
          { title: "Invalid Quantity", autoHideDelay: 3000, variant: "warning" }
        );
        return false;
      }

      if (scheduled > ordered) {
        item.quantity_scheduled = ordered;
        this.$bvToast.toast(
          `Scheduled quantity cannot exceed ordered quantity (${ordered})`,
          { title: "Invalid Quantity", autoHideDelay: 3000, variant: "warning" }
        );
        return false;
      }

      return scheduled >= 0 && scheduled <= ordered;
    },

    validateReceivedQuantity(item) {
      const min = this.getMinQuantity(item);
      const max = item.quantity_ordered;
      return item.quantity_received >= min && item.quantity_received <= max;
    },

    validateOrderedQuantityChange(item) {
      if (item.quantity_ordered < 1) {
        item.quantity_ordered = 1;
      }

      if (item.quantity_received > item.quantity_ordered) {
        item.quantity_received = item.quantity_ordered;
      }

      if (item.quantity_scheduled > item.quantity_ordered) {
        item.quantity_scheduled = item.quantity_ordered;
      }
    },

    handleScheduledQuantityChange(item) {
      const scheduledQty = Number(item.quantity_scheduled) || 0;

      if (scheduledQty > 0) {
        if (item.status !== 3) {
          item.status = 3;
        }

        if (!item.schedule_date) {
          item.schedule_date = this.mainScheduleDate || moment().format('MM-DD-YYYY');
        }
      } else if (scheduledQty === 0) {
        if ((item.quantity_received || 0) === 0 && ![5, 6].includes(item.status)) {
          item.status = item.quantity_ordered > 0 ? 2 : 1;
        }
      }

      this.validateScheduledQuantity(item);
    },

    handleScheduledDateChange(item) {
      if (item.schedule_date) {
        const preScheduledStatuses = [1, 2];
        if (preScheduledStatuses.includes(item.status)) {
          item.status = 3;
        }

        if ((!item.quantity_scheduled || item.quantity_scheduled === 0) && item.quantity_ordered > 0) {
          item.quantity_scheduled = item.quantity_ordered;
        }
      }
    },

    pullFinalEtaIfScheduleDateNull(item) {
      if (!item.schedule_date && this.final_eta) {
        item.schedule_date = this.final_eta;

        const preScheduledStatuses = [1, 2];
        if (preScheduledStatuses.includes(item.status)) {
          item.status = 3;
        }
      }
    },

    showImages(pictures) {
      pictures.forEach(pic => {
        if (pic.url) {
          window.open(pic.url, '_blank');
        }
      });
    },

    handleImageUpload(event, item, idx) {
      const input = event.target;
      if (input.files && input.files[0]) {
        const img = { raw: "", url: "", file: null };
        const reader = new FileReader();
        reader.onload = (e) => {
          img.raw = e.target.result;
          if (!item.images) this.$set(item, 'images', []);
          item.images = [img];
          this.$set(this.items, idx, item);
        };
        img.file = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },

    removeImage(item, idx) {
      item.images = [];
      this.$refs['fileInput-' + idx][0].value = '';
      this.$set(this.items, idx, item);
    },

    showImagePreview(item) {
      if (!item.images || item.images.length === 0) return;
      this.$bvModal.msgBoxOk('', {
        title: 'Image Preview',
        centered: true,
        size: 'lg',
        headerBgVariant: 'dark',
        headerTextVariant: 'light',
        bodyClass: 'text-center',
        content: () => (
          <div>
            <img src={item.images[0].raw} style="max-width: 100%; max-height: 70vh;" />
          </div>
        )
      });
    },

    getLocationName(locId) {
      const loc = this.packet.locsubs.find(l => l.value.toString() === locId.toString());
      return loc ? loc.text : 'Location ' + locId;
    },

    validate: function (data) {
      let errors = [];

      if (!data.items || data.items.length <= 0) {
        errors.push({ message: "PLEASE ADD AT LEAST ONE PRODUCT IN THIS ORDER." });
        return errors;
      }

      for (let i = 0; i < data.items.length; i++) {
        const item = data.items[i];
        const quantityReceived = Number(item.quantity_received) || 0;
        const quantityOrdered = Number(item.quantity_ordered) || 0;
        const status = Number(item.status);
        const originalQuantityReceived = Number(item.original_quantity_received) || 0;

        const fobPrice = parseFloat(item.fob_price);
        if (isNaN(fobPrice) || fobPrice < 0) {
          errors.push({ message: `ITEM ${i + 1}: PLEASE ENTER A VALID FOB PRICE.` });
        }

        if (!item.product_sku) {
          errors.push({ message: `ITEM ${i + 1}: PRODUCT SKU IS MISSING.` });
        }

        if (!quantityOrdered || quantityOrdered <= 0) {
          errors.push({ message: `ITEM ${i + 1}: PLEASE SPECIFY A VALID ORDERED QUANTITY.` });
        }

        if (quantityReceived < 0) {
          errors.push({ message: `ITEM ${i + 1}: QUANTITY RECEIVED CANNOT BE NEGATIVE.` });
        }

        if (quantityReceived > quantityOrdered) {
          errors.push({ message: `ITEM ${i + 1}: QUANTITY RECEIVED (${quantityReceived}) CANNOT EXCEED ORDERED (${quantityOrdered}).` });
        }

        if (quantityReceived > 0 && ![5, 6].includes(status)) {
          errors.push({ message: `ITEM ${i + 1}: STATUS MUST BE "PARTIAL" OR "RECEIVED" WHEN QUANTITY IS RECEIVED.` });
        }

        if (originalQuantityReceived === 0) {
          if (quantityReceived > 0 && quantityReceived < quantityOrdered && status !== 5) {
            errors.push({ message: `ITEM ${i + 1}: STATUS MUST BE "PARTIAL" WHEN RECEIVING PARTIAL QUANTITY (${quantityReceived} OF ${quantityOrdered}).` });
          } else if (quantityReceived === quantityOrdered && status !== 6) {
            errors.push({ message: `ITEM ${i + 1}: STATUS MUST BE "RECEIVED" WHEN FULL QUANTITY IS RECEIVED.` });
          }
        }

        if ([6].includes(status) && !item.receiving_date) {
          errors.push({ message: `ITEM ${i + 1}: RECEIVING DATE IS REQUIRED FOR RECEIVED STATUS.` });
        }

        if (status === 6) {
          if (quantityReceived === 0) {
            errors.push({ message: `ITEM ${i + 1}: QUANTITY RECEIVED CANNOT BE ZERO WHEN STATUS IS "RECEIVED".` });
          } else if (quantityReceived < quantityOrdered) {
            errors.push({ message: `ITEM ${i + 1}: STATUS CANNOT BE "RECEIVED" IF QUANTITY RECEIVED (${quantityReceived}) < ORDERED (${quantityOrdered}). USE "PARTIAL" INSTEAD.` });
          }
        } else if (status === 5) {
          if (quantityReceived === 0) {
            errors.push({ message: `ITEM ${i + 1}: QUANTITY RECEIVED CANNOT BE ZERO WHEN STATUS IS "PARTIAL".` });
          } else if (quantityReceived >= quantityOrdered) {
            errors.push({ message: `ITEM ${i + 1}: STATUS CANNOT BE "PARTIAL" IF QUANTITY RECEIVED (${quantityReceived}) ≥ ORDERED (${quantityOrdered}). USE "RECEIVED" INSTEAD.` });
          }
        }

        if (status === 3 && !item.schedule_date) {
          errors.push({ message: `ITEM ${i + 1}: "SCHEDULED" STATUS REQUIRES A SCHEDULE DATE.` });
        }
      }
      return errors;
    },

    getChangedItems() {
      return this.items.filter(item => {
        if (!item.stock_order_item_id) {
          return true;
        }

        const changes = [
          item.quantity_received != item.original_quantity_received,
          item.status != item.original_status,
          item.quantity_scheduled != item.original_quantity_scheduled,
          item.fob_price != item.original_fob_price,
          item.landed_cost_calculated != item.original_landed_cost_calculated,
          item.locsub != item.original_locsub,
          item.schedule_date != item.original_schedule_date,
          item.receiving_date != item.original_receiving_date,
          item.comments != item.original_comments,
          item.color != item.original_color
        ];

        return changes.some(change => change === true);
      });
    },

    save_stock_order_items: function () {
      const changedItems = this.getChangedItems();

      if (changedItems.length === 0) {
        this.$bvToast.toast(
          "No changes to save",
          {title: "No Changes", autoHideDelay: 3000, variant:"info"}
        );
        return;
      }

      let data = {
        stock_order_id: this.stock_order_id,
        items: changedItems,
        created_by: this.packet.userDetails.username,
        location_id: this.packet.userDetails.properties.location_id
      }

      let errors = this.validate(data);
      if (errors.length > 0) {
        this.$bvToast.toast(errors[0].message, {
          title: "Validation Error",
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }

      let that = this;
      let path = "/api/vendor/save_stock_order_items/";

      let s = function (response) {
        if (response.data.error) {
          that.$bvToast.toast(
            response.data.error,
            { title: "Error", autoHideDelay: 3000, variant: "danger" }
          );
        } else {
          that.$bvToast.toast(
            "Changes saved successfully!",
            { title: "Success", autoHideDelay: 2000, variant: "success" }
          );
          that.loading = false;

          changedItems.forEach(item => {
            item.original_quantity_received = item.quantity_received;
            item.original_status = item.status;
            item.original_quantity_scheduled = item.quantity_scheduled;
            item.original_fob_price = item.fob_price;
            item.original_landed_cost = item.landed_cost;
            item.original_locsub = item.locsub;
            item.original_schedule_date = item.schedule_date;
            item.original_receiving_date = item.receiving_date;
            item.original_comments = item.comments;
            item.original_color = item.color;

            if (response.data.saved_ids && response.data.saved_ids[item.product_sku]) {
              item.stock_order_item_id = response.data.saved_ids[item.product_sku];
            }
          });

          that.fetchStockOrderHistory();
          that.close_it();
        }
        that.loading = false;
      };

      let f = function (error) {
        console.error("Save error:", error);
        that.$bvToast.toast(
          "Error occurred while saving. Please try again.",
          { title: "Error", autoHideDelay: 3000, variant: "danger" }
        );
        that.loading = false;
      };

      this.loading = true;
      Requestor.postSyncP(path, data, this, s, f);
    },

    add_custom_item: function (e) {
      let idx = this.items.length;
      let item = {
        idx: idx + 1,
        product_sku: null,
        product_name: null,
        category_id: null,
        vendor_id: this.vendor_id,
        cubes: null,
        quantity: null,
        fob_price: null,
        selling_price: null,
        landed_cost: null,
        wholesale_price: null,
        product_type: 2,
        receiving_location_id: null,
        receiving_sublocation_id: null,
        original_quantity_received: null,
        original_status: null,
        created_by: this.packet.userDetails.username,
      };
      this.items.push(item);
    },

    validateQuantity(item) {
      const min = this.getMinQuantity(item);
      const max = item.quantity_ordered;

      this.$nextTick(() => {
        let received = Number(item.quantity_received) || 0;

        if (received < min) {
          received = min;
          this.$bvToast.toast(
            `Quantity received cannot be less than ${min}`,
            { title: "Invalid Quantity", autoHideDelay: 3000, variant: "warning" }
          );
        } else if (received > max) {
          received = max;
          this.$bvToast.toast(
            `Quantity received cannot exceed ordered quantity (${max})`,
            { title: "Invalid Quantity", autoHideDelay: 3000, variant: "warning" }
          );
        }

        item.quantity_received = received;

        if (received > 0) {
          item.status = received === max ? 6 : 5;

          if (item.status === 6 && !item.receiving_date) {
            item.receiving_date = moment().format('MM-DD-YYYY');
          }
        } else {
          if (item.original_status && item.original_status !== 6) {
            item.status = item.original_status;
          } else {
            item.status = 2;
          }

          item.receiving_date = null;
        }
      });
    },

    debugChangedItems() {
      const changed = this.getChangedItems();
      console.log('Changed items:', changed);
    },

    getMinQuantity(item) {
      return item.original_quantity_received || 0;
    },

    getMinScheduledQuantity(item) {
      if (item.status == 3) {
        return 1;
      }
      return 0;
    },

    add_item: function (e) {
      if (this.items.filter(function (d) { return d.product_sku == e.product_sku }).length > 0) {
        this.$bvToast.toast(
          "This product is already in the order",
          { title: "Duplicate Product", autoHideDelay: 3000, variant: "warning" }
        );
        return;
      }

      const defaultSubLocation = this.filteredLocations.length > 0 ?
        this.filteredLocations[0].value : this.receiving_location_id;

      let idx = this.items.length;
      let item = {
        idx: idx + 1,
        product_sku: e.product_sku,
        product_name: e.product_name,
        category_id: e.category_id,
        vendor_id: e.vendor_id,
        cubes: e.cubes,
        quantity_ordered: 1,
        quantity_scheduled: 0,
        quantity_received: 0,
        original_quantity_received: e.quantity_received || 0,
        locsub: defaultSubLocation,
        fob_price: e.fob_price ? parseFloat(e.fob_price) : 0,
        selling_price: e.selling_price,
        landed_cost_calculated: e.landed_cost ? parseFloat(e.landed_cost) : null,
        wholesale_price: e.wholesale_price,
        product_type: e.product_type,
        pictures: [],
        receiving_date: null,
        schedule_date: null,
        color: null,
        stock_order_id: this.stock_order_id,
        original_status: e.status || 1,
        status: e.status || 1,
        original_quantity_received: 0,
        original_status: 1,
        original_quantity_scheduled: 0,
        original_fob_price: e.fob_price ? parseFloat(e.fob_price) : null,
        original_landed_cost_calculated: e.landed_cost ? parseFloat(e.landed_cost) : null,
        original_locsub: defaultSubLocation,
        original_schedule_date: null,
        original_receiving_date: null,
        original_comments: null,
        original_color: null,
      };
      this.items.push(item);
      this.product_search_keyword = '';
    },

    remove_item: function (product_sku) {
      this.items = this.items.filter(function (d) {
        return d.product_sku != product_sku
      });
    },

    filter_products: function (item, query) {
      return (
        item.product_name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
        item.product_sku.toLowerCase().indexOf(query.toLowerCase()) > -1
      )
    },

    preventInvalidEntry(event, item) {
      const allowedKeys = [8, 9, 13, 37, 38, 39, 40, 46];
      if (allowedKeys.includes(event.keyCode)) return;

      if (!/[\d.]/.test(event.key)) {
        event.preventDefault();
        return;
      }

      const currentValue = event.target.value;
      const newValue = currentValue.slice(0, event.target.selectionStart) +
                      event.key +
                      currentValue.slice(event.target.selectionEnd);

      const min = this.getMinQuantity(item);
      const max = item.quantity_ordered;

      if (newValue !== '' && (isNaN(newValue) || parseFloat(newValue) < min || parseFloat(newValue) > max)) {
        event.preventDefault();
        this.$bvToast.toast(
          `Value must be between ${min} and ${max}`,
          { title: "Invalid Entry", autoHideDelay: 3000, variant: "warning" }
        );
      }
    },

    fetch_init: function () {
      let data = {
        stock_order_id: this.stock_order_id
      }
      let path = "/api/vendor/get_stock_order_items/";
      let that = this;

      let s = function (response) {
        if (response.data.error) {
          that.$bvToast.toast(
            "ERROR RETRIEVING STOCK ORDER ITEMS",
            { title: "Error", autoHideDelay: 3000, variant: "warning" }
          );
        } else {
          that.receiving_location_id = response.data.receiving_location;
          that.final_eta = response.data.final_eta;

          that.items = response.data.result.map(item => {
            if (!item.stock_order_item_id && item.id) {
              item.stock_order_item_id = item.id;
            }
            
            if (!item.locsub || !item.locsub.toString().startsWith(that.receiving_location_id)) {
              const firstSub = that.packet.locsubs.find(loc =>
                loc.value.toString().startsWith(that.receiving_location_id + '|')
              );
              if (firstSub) {
                item.locsub = firstSub.value;
              } else {
                item.locsub = that.receiving_location_id;
              }
            }

            if (!item.schedule_date && that.final_eta) {
              item.schedule_date = that.final_eta;
              const preScheduledStatuses = [1, 2];
              if (preScheduledStatuses.includes(item.status)) {
                item.status = 3;
              }
            }

            if (item.status) {
              item.original_status = item.status;
            }

            if (item.quantity_received) {
              item.original_quantity_received = item.quantity_received;
            }
            item.original_quantity_received = item.quantity_received;
            item.original_status = item.status;
            item.original_quantity_scheduled = item.quantity_scheduled;
            item.original_fob_price = item.fob_price;
            item.original_landed_cost = item.landed_cost;
            item.original_locsub = item.locsub;
            item.original_schedule_date = item.schedule_date;
            item.original_receiving_date = item.receiving_date;
            item.original_comments = item.comments;
            item.original_color = item.color;

            return item;
          });
        }
        that.loading = false;
      };

      let f = function (error) {
        that.$bvToast.toast(
          "Error retrieving order items.",
          { title: "Error", autoHideDelay: 3000, variant: "danger" }
        );
        that.loading = false;
      };

      this.loading = true;
      Requestor.getSyncP(path, data, this, s, f);
    },

    isItemDisabled(item) {
      if (item.original_status === 6) {
        return this.packet.userDetails.userrole !== '';
      }
      return false;
    },

    handleStatusChange(item) {
      if (item.status === 6) {
        item.quantity_received = item.quantity_ordered;
        item.receiving_date = moment().format('MM-DD-YYYY');
      } else if (item.status === 5 && item.quantity_received === 0) {
        item.quantity_received = this.getMinQuantity(item) || 1;
      }
      if (item.status === 1) {
        if (!item.quantity_ordered || item.quantity_ordered < 0) {
          item.status = 2;
        }
      }

      if (item.status === 3) {
        if (!item.schedule_date) {
          item.schedule_date = moment().format('MM-DD-YYYY');
        }
        if (!item.quantity_scheduled || item.quantity_scheduled < 1) {
          item.quantity_scheduled = 1;
        }
      }

      if (item.original_status === 6 && item.status !== 6) {
        item.receiving_date = null;
      }
    },

    getStatusState(item) {
      if (item.quantity_received > 0) {
        return [5, 6].includes(item.status) ? null : false;
      }
      return null;
    },

    fetch_prereqs: function () {
      if (this._productsRequested) return;
      this._productsRequested = true;

      let data = {};
      let path = "/api/product/get_product_list_v5/";
      let that = this;

      let s = function (response) {
        if (response.data.error) {
          console.error("Error fetching products:", response.data.error);
          that.products = [];
        } else {
          that.products = response.data.result || [];
          that.products = that.products.filter(function (d) {
            return d.vendor_id == that.stock_order_vendor_id;
          });

          if (that.products.length === 0) {
            that.$bvToast.toast(
              `No products available for vendor: ${that.packet.vendorsdict[that.stock_order_vendor_id]}`,
              { title: "No Products", autoHideDelay: 5000, variant: "warning" }
            );
          }

          that.fetch_init();
        }
        that.loading = false;
      };

      let f = function (error) {
        that.$bvToast.toast(
          "Error retrieving products.",
          { title: "Error", autoHideDelay: 3000, variant: "danger" }
        );
        that.loading = false;
      };

      this.loading = true;
      Requestor.getSyncP(path, data, this, s, f);
    },

    filter_products_for_vendor: function () {
      this.vendor_products = this.products.filter(function (d) {
        return d.vendor_id == this.vendor_id;
      });
    },

    close_it: function () {
      this.$emit("done-items-so", this.items);
    },

    fetchStockOrderHistory: function() {
      let data = {id: this.stock_order_id}
      let path = "/api/vendor/get_stock_order_history/"
      let that = this;
      let s = function(response) {
        if (response.data.error){
          that.$bvToast.toast(
            "ERROR RETRIEVING STOCK ORDER HISTORY",
            {title: "Error", autoHideDelay: 1500, variant:"warning"}
          );
        } else {
          that.stockOrderHistory = response.data.result;
        }
        that.historyLoading = false;
      }

      let f = function(error) {
        that.$bvToast.toast(
          "ERROR OCCURRED WITH HISTORY. PLEASE TRY LATER.",
          {title: "Error", autoHideDelay: 1500, variant:"danger"}
        );
        that.historyLoading = false;
      }
      this.historyLoading = true;
      Requestor.getSyncP(path, data, this, s, f);
    },
  },
  watch: {
    mainScheduleDate(newDate) {
      if (newDate && this.autoApplyMainDate) {
        this.applyMainScheduleDate();
      }
    },
    // ADDED: Auto-apply receiving location when it changes
    mainReceivingLocation(newLocation) {
      if (newLocation) {
        this.applyMainReceivingLocation();
      }
    },
    stock_order_id: function(newVal) {
      if (newVal) {
        this.fetchStockOrderHistory();
      }
    },
    items: {
      handler(newItems) {
        // Track changes
      },
      deep: true
    }
  },
  created: function () {
    this.packet = JSON.parse(localStorage.packet);
    this.packet.userDetails = JSON.parse(localStorage.userDetails);
    this.stock_order_id = JSON.parse(JSON.stringify(this.viewdata)).stock_order_id;
    this.stock_order_vendor_id = JSON.parse(JSON.stringify(this.viewdata)).stock_order_vendor_id;
    this.read_only = JSON.parse(JSON.stringify(this.viewdata)).read_only;
  },
  mounted: function () {
    this.fetch_prereqs();
    if (this.read_only != true) {
      this.fetch_prereqs();
    }
    if (this.stock_order_id) {
      this.fetchStockOrderHistory();
    }
    
    // Set default receiving location after component is ready
    this.$nextTick(() => {
      if (this.filteredLocations && this.filteredLocations.length > 0) {
        this.mainReceivingLocation = this.filteredLocations[0].value;
      }
    });
  },
}
</script>

<style scoped>
.input-field {
  width: 500px;
}

::v-deep .srrv .custom-select {
  background: transparent !important;
  border: 1px solid rgba(0,0,0,0.2) !important;
  color: inherit !important;
}

::v-deep .srrv .custom-select:disabled {
  background: rgba(240, 240, 240, 0.7) !important;
  opacity: 0.7;
}

.status-new { background-color: #f8f9fa; color: black; }
.status-ordered { background-color: #e3f2fd; color: black; }
.status-scheduled { background-color: #e1f5fe; color: black; }
.status-in-transit { background-color: #fff3e0; color: black; }
.status-partial { background-color: #fff9c4; color: black; }
.status-received { background-color: #c8e6c9; color: black; }
.status-completed { background-color: #1b5e20; color: white; }
.status-archived { background-color: #f5f5f5; color: black; }

.date .input-group-text {
  padding: 0;
  padding-left: 10px;
  padding-right: 10px;
}

.diver {
  overflow: auto;
  width: 100%;
  padding-bottom: 20px;
  position: relative;
}

table {
  table-layout: fixed;
  width: 100%;
    border-collapse: separate;
  border-spacing: 0;
}

.srrv:first-of-type,
.srrv:nth-of-type(2) {
  position: sticky;
  left: 0;
  background-color: white;
  z-index: 1;
}

thead .srr:first-of-type,
thead .srr:nth-of-type(2) {
  position: sticky;
  left: 0;
  background-color: #efefef;
  z-index: 2;
}

/* For the second column, we need to adjust its left offset
   to position it right after the first column */
.srrv:nth-of-type(2) {
  left: 100px; /* Width of the first column (PRODUCT SKU) */
}
thead .srr:nth-of-type(2) {
  left: 100px;
}

/* Since the second column (DESCRIPTION) is wider, we adjust its position.
   The first column (PRODUCT SKU) has a set width of 100px from your CSS. */
.srrv:first-of-type {
  left: 0;
}
thead .srr:first-of-type {
  left: 0;
}

/* We need to be more specific to ensure proper layering.
   The description column should be above the product sku column when scrolling. */
.srrv:nth-of-type(2),
thead .srr:nth-of-type(2) {
  z-index: 2;
}

/* Optional: Add a subtle box shadow to the sticky columns for better visual separation */
.srrv:first-of-type,
.srrv:nth-of-type(2),
thead .srr:first-of-type,
thead .srr:nth-of-type(2) {
  box-shadow: 2px 0 5px -2px rgba(0,0,0,0.1);
}

.srr {
  font-size: 11px;
  text-align: center;
  background: #efefef;
  border: 1px solid #010101;
}

.srrv {
  font-size: 11px;
  text-align: center;
  background: white;
  border: 1px solid #010101;
  padding: 5px;
}

.mx-input {
  font-size: 12px;
}

@media (max-width: 768px) {
  .input-field {
    width: 100%;
  }

  .srr, .srrv {
    min-width: 100px;
  }

  .diver {
    height: auto;
    overflow-x: auto;
    overflow-y: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/VendorOrders/StockOrderItems.vue